import React from 'react';
import { SearchableSelect } from './SearchableSelect';
import { SettingItem } from '../types';

interface FileUploadProps {
    selectedTags: SettingItem[];
    onSelectedTagsChange: (tags: SettingItem[]) => void;
    allTags: readonly SettingItem[];
    onAddTag: (tag: { name: string; color?: string }) => Promise<SettingItem>;
}

export const FileUpload: React.FC<FileUploadProps> = ({
    selectedTags,
    onSelectedTagsChange,
    allTags,
    onAddTag
}) => {
    return (
        <div className="w-full sm:w-48">
            <SearchableSelect
                isMulti
                value={selectedTags}
                onChange={(v) => onSelectedTagsChange(v as SettingItem[])}
                options={allTags}
                placeholder="Přiřadit štítky k nahrávce..."
                onAddItem={onAddTag}
            />
        </div>
    );
};